import { z } from 'zod';
/**
 * The account of the person using the product, as distinct from the
 * organisation they belong to.
 *
 * The name is the only thing here this product owns. The address and the
 * password belong to the identity provider, and are changed in its own screens
 * — which is also where the proof of a new address is demanded, as it has to
 * be somewhere: a product that let an address be swapped without that proof
 * would let anyone with a borrowed session redirect every reset email.
 */
export const profileSchema = z.object({
    name: z.string(),
    email: z.string(),
});
export const profileNameSchema = z.object({
    /**
     * Empty is allowed, and means "not given".
     *
     * A required name would make somebody invent one to get past the form, and an
     * invented name is worse than none — the screens fall back to the address,
     * which is at least true.
     */
    name: z.string().trim().max(120, 'a name can be up to 120 characters'),
});
//# sourceMappingURL=profile.js.map